import type { EditorState } from '@atlaskit/editor-prosemirror/state';

/**
 * Whether the cursor sits in a top-level paragraph, heading, or panel.
 * "Top-level" means the node is a direct child of the document root.
 * For panels the cursor is one level deeper (doc > panel > paragraph/heading).
 */
export function isCursorInAllowedNode(state: EditorState): boolean {
	const { $from } = state.selection;

	if ($from.depth === 1) {
		const name = $from.parent.type.name;
		return name === 'paragraph' || name === 'heading';
	}

	if ($from.depth === 2 && $from.node(1).type.name === 'panel') {
		const name = $from.parent.type.name;
		return name === 'paragraph' || name === 'heading';
	}

	return false;
}
